// extracted by mini-css-extract-plugin
module.exports = {"root":"_1aZKh","icon":"_1ICV4","badge":"_3s1Zi"};